// extracted by mini-css-extract-plugin
module.exports = {"image":"image-2aptf","content":"content-1V3FB"};